export function TxHistoryTableSkeleton() {
  return (
    <div className="relative">
      <div className="m-28 mx-auto mb-6 mt-8 w-full max-w-[1500px] rounded-xl border border-muted-50 border-slate-200 bg-background bg-white p-6 shadow-[0_0_10px_rgba(0,0,0,0.1)] dark:border-muted-200">
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <div className="h-7 w-40 animate-pulse rounded bg-muted-200" />
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 animate-pulse rounded bg-muted-200" />
              <div className="h-8 w-[180px] animate-pulse rounded bg-muted-200" />
            </div>
          </div>
        </div>

        {/* Transaction Records */}
        <div className="space-y-6">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className="rounded-lg border-2 border-gray-200 bg-muted-25 p-0 shadow-sm"
            >
              {/* Transaction Header */}
              <div className="flex flex-col justify-between gap-3 border-b border-muted-100 p-4 text-xs md:flex-row md:items-center">
                <div className="flex items-center gap-3">
                  <div className="relative flex h-10 w-10 items-center justify-center">
                    <div className="absolute inset-0 animate-pulse rounded-full border border-muted-50" />
                    <div className="h-7 w-7 animate-pulse rounded-full bg-muted-200" />
                  </div>
                  <div className="h-4 w-64 animate-pulse rounded bg-muted-200" />
                </div>
                <div className="flex items-center gap-4">
                  <div className="h-4 w-32 animate-pulse rounded bg-muted-200" />
                  <div className="h-4 w-32 animate-pulse rounded bg-muted-200" />
                  <div className="h-4 w-32 animate-pulse rounded bg-muted-200" />
                </div>
              </div>

              {/* Transaction Body */}
              <div className="grid grid-cols-1 gap-4 bg-white p-4 md:grid-cols-2">
                {/* Inputs */}
                <div>
                  <div className="mb-2 h-5 w-24 animate-pulse rounded bg-muted-200" />
                  <div className="overflow-hidden rounded-lg border border-gray-300 bg-gray-50 shadow-sm">
                    <table className="w-full table-fixed">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="h-8 w-1/4 p-2">
                            <div className="h-4 w-16 animate-pulse rounded bg-muted-200" />
                          </th>
                          <th className="w-1/4 p-2">
                            <div className="h-4 w-20 animate-pulse rounded bg-muted-200" />
                          </th>
                          <th className="w-1/4 p-2">
                            <div className="h-4 w-20 animate-pulse rounded bg-muted-200" />
                          </th>
                          <th className="w-1/4 p-2">
                            <div className="h-4 w-16 animate-pulse rounded bg-muted-200" />
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {[...Array(5)].map((_, i) => (
                          <tr key={i}>
                            <td className="p-3">
                              <div className="h-6 w-32 animate-pulse rounded bg-muted-200" />
                            </td>
                            <td className="p-3">
                              <div className="h-6 w-24 animate-pulse rounded bg-muted-200" />
                            </td>
                            <td className="p-3">
                              <div className="h-6 w-20 animate-pulse rounded bg-muted-200" />
                            </td>
                            <td className="p-3">
                              <div className="h-6 w-16 animate-pulse rounded bg-muted-200" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Outputs - Same structure as Inputs */}
                <div>
                  <div className="mb-2 h-5 w-24 animate-pulse rounded bg-muted-200" />
                  <div className="overflow-hidden rounded-lg border border-gray-300 bg-gray-50 shadow-sm">
                    <table className="w-full table-fixed">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="h-8 w-1/4 p-2">
                            <div className="h-4 w-16 animate-pulse rounded bg-muted-200" />
                          </th>
                          <th className="w-1/4 p-2">
                            <div className="h-4 w-20 animate-pulse rounded bg-muted-200" />
                          </th>
                          <th className="w-1/4 p-2">
                            <div className="h-4 w-20 animate-pulse rounded bg-muted-200" />
                          </th>
                          <th className="w-1/4 p-2">
                            <div className="h-4 w-16 animate-pulse rounded bg-muted-200" />
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {[...Array(5)].map((_, i) => (
                          <tr key={i}>
                            <td className="p-3">
                              <div className="h-6 w-32 animate-pulse rounded bg-muted-200" />
                            </td>
                            <td className="p-3">
                              <div className="h-6 w-24 animate-pulse rounded bg-muted-200" />
                            </td>
                            <td className="p-3">
                              <div className="h-6 w-20 animate-pulse rounded bg-muted-200" />
                            </td>
                            <td className="p-3">
                              <div className="h-6 w-16 animate-pulse rounded bg-muted-200" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Transaction Footer */}
              <div className="flex justify-end border-t border-gray-200 p-4">
                <div className="h-8 w-24 animate-pulse rounded-md bg-muted-200" />
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="mt-6 flex justify-center">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 animate-pulse rounded bg-muted-200" />
            <div className="h-8 w-8 animate-pulse rounded bg-muted-200" />
            <div className="h-8 w-8 animate-pulse rounded bg-muted-200" />
            <div className="h-8 w-8 animate-pulse rounded bg-muted-200" />
            <div className="h-8 w-8 animate-pulse rounded bg-muted-200" />
          </div>
        </div>
      </div>

      {/* Floating Button */}
      <div className="fixed right-8 top-1/2 z-50 -translate-y-1/2 transform">
        <div className="h-10 w-10 animate-pulse rounded-lg bg-muted-200" />
      </div>
    </div>
  );
}
